export const BUSINESS_HOURS = {
  START_TIME: 10,
  END_TIME: 19,
  SATURDAY_END_TIME: 17,
};
